require('./overrides.scss')

export default {
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#1abadb',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#f79803',
        error: '#FF4C51',
        anchor: '#FFFFFF',
      },
    },
  },
}
